import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import CloudUploadIcon from '../../../../../../components/Icons/CloudUploadIcon';
import ProgressModal from '../../../../../../components/ProgressModal/ProgressModal';
import TooltipCaller from '../../../../../../components/TooltipManager/TooltipCaller';
import {
  changeModalProps,
  closeModal,
  openModal,
} from '../../../../../../store/modules/ModalActions';
import { getElementID, getMergedClassNames } from '../../../../../../utils/HTMLUtils';
import arquivosStyles from '../Arquivos.scss';
import styles from './UploadAssinadoButton.scss';
import { uploadContrato } from '../../../../../../store/modules/ContratosActions';
import SnackbarUtils from 'utils/SnackbarUtils';

const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  modalKey: null,
};

class UploadAssinadoButton extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  getArquivoId = () => {
    return this.props.arquivo.idDocAssinado;
  };

  isShown = () => {
    return (
      (!this.getArquivoId() &&
        this.props.auth.userPermissions.contratos.assessor.upload) ||
      this.props.auth.userPermissions.contratos.assessor.changeUpload
    );
  };

  closeModal = () => {
    this.props.closeModal(this.state.modalKey);
    this.setState({
      modalKey: null,
    });
  };

  onCallbackProgress = (event) => {
    const percent = event.percent;
    if (this.state.modalKey) {
      this.props.changeModalProps(this.state.modalKey, {
        percent: percent,
      });
    }
  };

  onCallbackSuccess = () => {
    this.closeModal();
    SnackbarUtils.enqueueSnackbar({
      message: this.props.languageValues.successUploadDocumentoAssinado,
      options: {
        variant: 'success',
      },
    });
    this.props.refreshStep();
  };

  onCallbackError = (error) => {
    this.closeModal();
    SnackbarUtils.enqueueSnackbar({
      message:
        error.response.statusText ||
        this.props.languageValues.errorUploadDocumentoAssinado,
      options: {
        variant: 'error',
      },
    });
  };

  upload = (file) => {
    const arquivo = this.props.arquivo;
    const modalKey = this.props.openModal(ProgressModal, {
      title:
        this.props.languageValues.cadastroContratoArquivosUploadingAssinado,
      percent: 0,
    }).payload.key;

    this.setState(
      {
        modalKey,
      },
      () => {
        this.props.uploadContrato(
          file,
          arquivo.id,
          arquivo.versaoContrato,
          this.onCallbackSuccess,
          this.onCallbackError,
          this.onCallbackProgress
        );
      }
    );
  };

  onClick = () => {
    this.download();
  };

  isLoading = () => {
    return this.props.contratosAssessores.loadingAlteraStatus;
  };

  isDisabled = () => {
    const arquivo = this.props.arquivo;
    return (
      this.isLoading() ||
      this.props.contratosAssessores.loadingAlteraArquivo ||
      (!this.props.auth.userPermissions.contratos.editEvenWhenDisabled &&
        (!arquivo.isLatest || !arquivo.idDocNaoAssinado || !arquivo.ativo))
    );
  };

  render() {
    const arquivo = this.props.arquivo;
    return arquivo && this.isShown() ? (
      <TooltipCaller
        text={this.props.languageValues.cadastroContratoArquivosUploadAssinado}
        className={getMergedClassNames([
          rootClassName,
          this.isDisabled() ? rootClassName + '-disabled' : '',
          arquivosStyles.rootClassName + '-action-button',
          arquivosStyles.rootClassName + '-action-button-tooltip-caller',
        ])}
      >
        <CustomIconButton
          className={arquivosStyles.rootClassName + '-action-button'}
          tooltipProps={{
            className:
              arquivosStyles.rootClassName + '-action-button-tooltip-caller',
          }}
          size='small'
          icon={<CloudUploadIcon />}
          theme='pufvYellow'
          disabled={this.isDisabled()}
        />
        <input
          id={getElementID(this.props.id, 'upload-assinado-' + arquivo.id)}
          className={getMergedClassNames([rootClassName + '-input-file'])}
          type='file'
          onChange={(event) => {
            const files = event.target.files;
            if (files && files.length > 0) {
              this.upload(files[0]);
            }
          }}
          disabled={this.isDisabled()}
        />
      </TooltipCaller>
    ) : null;
  }
}

UploadAssinadoButton.propTypes = {
  id: PropTypes.string.isRequired,
  arquivo: PropTypes.object.isRequired,
  refreshStep: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
      openModal,
      changeModalProps,
      uploadContrato,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadAssinadoButton);
